export function now(): number {
  return Date.now();
}
